<div class="section" style="display: flex; flex-direction: column; height: 800px; width: 800px;" data-cy="treatment-report-main-container">
  <div class="section-header" style="flex-basis: 30px;" data-cy="treatment-report-header-container">
    <div class="section-header-title" data-cy="treatment-report-title-label">
      Treatment Plan
    </div>
    <div style="flex: 1;"></div>
  </div>
  @if (isLoading) {
    <app-tdo-progress-spinner data-cy="treatment-report-progress-spinner"></app-tdo-progress-spinner>
  }
  @if (!isLoading) {
    <div id="pdf-content" class="section-content" style="flex: 1; display: flex; flex-direction: column; overflow-y: hidden;" data-cy="treatment-report-pdf-content-container">
      <!--    CONTENT-->
      <div style="flex: 1; overflow-y: auto;" data-cy="treatment-report-content-scroll-container">
        @if (treatmentPlanOptions.length > 1) {
          <mat-form-field data-cy="treatment-report-options-form-field">
            <mat-label data-cy="treatment-report-options-label">Select an option</mat-label>
            <mat-select (ngModelChange)="handleOptionChange($event)" [(ngModel)]="selectedInvoiceIndex" data-cy="treatment-report-options-select">
              @for (option of invoiceArray; track option; let i = $index) {
                <mat-option [value]="i" data-cy="treatment-report-option-{{i}}">
                  {{option.name}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        <div id="main-plan-container" data-cy="treatment-report-plan-details-container">
          <div class="invoice-header-container" data-cy="treatment-report-invoice-header-container">
            <div class="invoice-header" data-cy="treatment-report-invoice-title-label">
              {{ dataInvoiceItem.title }}
            </div>
            @if (dataInvoiceItem.showImage) {
              <div class="invoice-image-container" data-cy="treatment-report-invoice-image-container">
                <img class="invoice-image" src="https://tdoxfilestore.blob.core.windows.net/testing/practice-logo2.png" data-cy="treatment-report-invoice-image" />
              </div>
            }
          </div>
          <mat-divider data-cy="treatment-report-divider-1"></mat-divider>
          <div class="invoice-sub-header" data-cy="treatment-report-invoice-sub-header-container">
            <div class="date-field" data-cy="treatment-report-date-field-container">
              <div class="date-header" data-cy="treatment-report-date-label">Date: </div>
              <div class="date-data" data-cy="treatment-report-date-value-label">{{ dataInvoiceItem.invoiceDate | date }} </div>
            </div>
            <div class="status-field" data-cy="treatment-report-status-field-container">
              <div class="date-header" data-cy="treatment-report-status-label">Status: </div>
              <div class="date-data" data-cy="treatment-report-status-value-label">{{ dataInvoiceItem.status }} </div>
            </div>
          </div>
          <mat-divider data-cy="treatment-report-divider-2"></mat-divider>
          <mat-divider data-cy="treatment-report-divider-3"></mat-divider>
          <div class="services-container" data-cy="treatment-report-services-container">
            @for (columnHeader of dataInvoiceItem.columns; track columnHeader) {
              <div class="service-column"
                [class.hide-column]="!columnHeader.show"
                data-cy="treatment-report-service-column-{{columnHeader.key}}">
                <div class="column-header" data-cy="treatment-report-column-header-{{columnHeader.key}}">
                  {{ columnHeader.title }}
                </div>
                @for (item of dataInvoiceItem.billableItems; track item) {
                  <div class="column-item-display-value" [class.hide-column]="!item.showItem" data-cy="treatment-report-column-item-{{columnHeader.key}}-{{item.key}}">
                    @if (columnHeader.pipe === 'date') {
                      <div data-cy="treatment-report-column-item-value-date-{{columnHeader.key}}-{{item.key}}">
                        {{ item[columnHeader.key] | date }}
                      </div>
                    }
                    @if (columnHeader.pipe === 'currency') {
                      <div data-cy="treatment-report-column-item-value-currency-{{columnHeader.key}}-{{item.key}}">
                        {{ item[columnHeader.key] | currency }}
                      </div>
                    }
                    @if (columnHeader.pipe === 'trim') {
                      <div data-cy="treatment-report-column-item-value-trim-{{columnHeader.key}}-{{item.key}}">
                        {{ trimName(item[columnHeader.key]) }}
                      </div>
                    }
                    @if (columnHeader.pipe === 'none') {
                      <div data-cy="treatment-report-column-item-value-none-{{columnHeader.key}}-{{item.key}}">
                        {{ item[columnHeader.key] }}
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
          <mat-divider data-cy="treatment-report-divider-4"></mat-divider>
          <div class="total-container" data-cy="treatment-report-total-container">
            <div class="total-header" data-cy="treatment-report-total-due-label">
              Total due:
            </div>
            <div class="total-data" data-cy="treatment-report-total-due-value-label">
              {{ dataInvoiceItem.totalDue | currency }}
            </div>
          </div>
        </div>
      </div>
      <div style="flex-basis: 200px; min-height: 200px; display: flex; flex-direction: column;" data-cy="treatment-report-note-main-container">
        <div style="flex-basis: fit-content;" data-cy="treatment-report-note-label">Note:</div>
        <div style="flex: 1; border: 1px solid var(--tdo-secondary); border-radius: var(--border-radius); overflow-y: auto; padding: 10px;" data-cy="treatment-report-note-content-container">
          {{note?.Note}}
        </div>
      </div>
    </div>
  }
  <div class="section-footer" style="flex-basis: 50px; padding-top: 6px;" data-cy="treatment-report-footer-container">
    <div style="flex: 1; margin-right: 6px;"></div>
    <button mat-raised-button class="tdo-button primary-accent" style="margin-right: 4px;" (click)="generatePDF()" data-cy="treatment-report-generate-pdf-button"><i class="material-icons" data-cy="treatment-report-generate-pdf-icon">picture_as_pdf</i></button>
    <button mat-raised-button class="tdo-button primary-accent" style="margin-right: 4px;" (click)="close()" data-cy="treatment-report-done-button">Done</button>
  </div>
</div>

